import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProviderTypes } from '@guryou/core';
import { Block, LargeText } from '@guryou/html-components';
import { checkIfUserEmailVerified } from '@guryou/utils/build/validations';
import EmailNotVerified from 'onboard/components/EmailNotVerified';
import MobileWarningMessage from 'onboard/components/MobileWarningMessage';
import ProviderType from 'onboard/components/ProviderType';
import useIsMobile from 'onboard/utils/useIsMobile';

const ChooseProviderType = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [showVerify, setShowVerify] = useState(true);

  const handleCloseVerify = () => setShowVerify(false);

  const isVerified = checkIfUserEmailVerified();

  return (
    <>
      {isMobile && <MobileWarningMessage />}
      {!isVerified && showVerify && <EmailNotVerified onClose={handleCloseVerify} />}
      <Block display="flex" flexDirection="column" alignItems="center" marginTop={10}>
        <LargeText marginBottom={6} textAlign="center">
          {t('ONBOARD.chooseCategory')}
        </LargeText>
        <ProviderType type={ProviderTypes.centers} />
        <ProviderType type={ProviderTypes.professionals} />
      </Block>
    </>
  );
};

export default ChooseProviderType;
